import { Component, ChangeDetectorRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { GenericBulkUpsertLandingComponent } from '../../shared/containers/generic-bulk-upsert-landing.component';
import { GenericBulkUpsertService } from '../../shared/services/generic-bulk-upsert.service';
import { RATE_AGREEMENT_BULK_UPSERT_FIELDS } from '../models/rate-agreement-bulk-upsert.model';
import { GenericBulkUpsertFeatureState } from '../../shared/store';

@Component({
  selector: 'rate-agreement-bulk-upsert-landing',
  templateUrl: '../../shared/containers/generic-bulk-upsert-landing.component.html'
})
export class RateAgreementBulkUpsertLandingComponent extends GenericBulkUpsertLandingComponent {
  title = 'Rate Agreement';
  validateEndpoint = 'api/RateAgreement/bulk/validate';
  uploadEndpoint = 'api/RateAgreement/bulk/upload';
  fields = RATE_AGREEMENT_BULK_UPSERT_FIELDS;
  templateFilename = 'rate-agreement_bulk_upsert_template.csv';

  constructor(
    protected store: Store<GenericBulkUpsertFeatureState>, 
    protected cdr: ChangeDetectorRef,
    protected genericService: GenericBulkUpsertService
  ) {
    super(store, cdr, genericService);
  }
}
